import { Bitmap, Color, MovieClip, TextFormat } from "../runtime";
import type { UnlockMessageId } from "../content/types";
import { G_unlockBox } from "./assets";
import { UNLOCK_MESSAGES } from "./data/unlockMessages";
import { FONT_BODY, TEXT_COLOURS, createTextField } from "./textStyle";

/**
 * Centre-screen "CONGRATULATIONS" plaque shown when a mission, survival mode
 * or the first-run hint is unlocked. It waits 30 frames, pops in with a white
 * flash, accepts SPACE ten frames later and then fades itself out.
 */
export class UnlockBox extends MovieClip {
  private readonly messageId: UnlockMessageId;
  private readonly format: TextFormat;
  private readonly delayLimit = 30;
  private fading = false;
  private life = 0;
  private pressable = false;
  private alphaCurrent = 100;
  private light = 120;

  constructor(messageId: UnlockMessageId) {
    super();
    this.format = new TextFormat();
    this.x = 360;
    this.y = 180;
    this.messageId = messageId;
    const boxSpr = new Bitmap(new G_unlockBox());
    boxSpr.x = boxSpr.width * -0.5;
    boxSpr.y = boxSpr.height * -0.5;
    this.addChild(boxSpr);
    this.format.align = "center";
    this.format.font = FONT_BODY;
    this.format.color = TEXT_COLOURS.white;
    this.format.size = 16;
    this.visible = false;
  }

  /** True once the plaque has faded out and can be removed. */
  update(input = false): boolean {
    ++this.life;
    if (this.life === this.delayLimit) {
      this.appear();
    }
    if (this.life === this.delayLimit + 10) {
      this.pressable = true;
    }
    if (this.pressable && input) {
      this.pressable = false;
      this.fading = true;
    }
    if (this.fading && this.alphaCurrent > 0) {
      this.alphaCurrent -= 5;
      this.alpha = this.alphaCurrent * 0.01;
      if (this.alphaCurrent === 0) {
        return true;
      }
    }
    if (this.light > 0) {
      this.light -= 20;
      this.updateGlow();
    }
    return false;
  }

  private appear(): void {
    this.visible = true;
    createTextField(this, this.format, {
      width: 484,
      height: 100,
      centerX: true,
      y: -46,
      text: UNLOCK_MESSAGES[this.messageId],
    });
    this.light = 140;
    this.updateGlow();
  }

  private updateGlow(): void {
    const c = new Color();
    c.setTint(16777215, this.light * 0.01);
    this.transform.colorTransform = c;
  }
}
